import httpService from '../Api/http.service';
import Utils from 'Shared/Utils';
import { getApiBaseUrl } from 'utils';

const fetchGroupByPartnerId = (paramsObj, product = 'recur', includeInactive = false) => {
  let qParams = Utils.getQueryString({ ...paramsObj, product });
  qParams = qParams ? `?${qParams}` : '';

  return httpService({
    url: `/groups${qParams}`,
    method: 'get',
  }).then(response => {
    if (!includeInactive && response?.data?.rows) {
      response.data.rows = response.data.rows.filter(group => group.status === 'Active');
    }
    return response;
  });
};

const createGroup = (payload) =>
  httpService({
    url: `/group`,
    method: 'post',
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

const deleteGroup = (payload) =>
  httpService({
    url: `/group`,
    method: 'delete',
    data: payload,
  });

const getAllMaterials = (group_id) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/groups/${group_id}/marketing-materials`,
    method: 'get',
  });

const createFileUploadLink = () =>
  httpService({
    url: `/file/upload-link`,
    method: 'post',
  });

const uploadFile = (url, payload) =>
  httpService({
    url: url,
    data: payload,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
  });

const updateMarketingMaterial = (marketingMaterialId, payload) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/marketing-materials/${marketingMaterialId}`,
    method: 'patch',
    data: payload,
  });

const deleteMarketingMaterial = (marketingMaterialId) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/marketing-materials/${marketingMaterialId}`,
    method: 'delete',
  });

const insertMarketingMaterial = (payload) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/marketing-materials`,
    method: 'post',
    data: payload,
  });

const requestPrintMaterial = (group_id, payload) =>
  httpService({
    url: `${getApiBaseUrl()}/loop/groups/${group_id}/marketing-materials/print`,
    method: 'put',
    data: payload,
  });

const getDisclosureDetails = (group_id) =>
  httpService({
    url: `${getApiBaseUrl()}/subscriberportal/terms-details/${group_id}`,
    method: 'get',
  });

const getGroupDisclosurePdf = (group_id) =>
  httpService({
    url: `${getApiBaseUrl()}/subscriberportal/groups/${group_id}/disclosure/pdf`,
    method: 'get',
  });

const getGroupSettings = (group_id) =>
  httpService({
    url: `${getApiBaseUrl()}/subscriberportal/settings?group_id=${group_id}`,
    method: 'get',
  });

const groupService = {
  fetchGroupByPartnerId,
  createGroup,
  deleteGroup,
  getAllMaterials,
  createFileUploadLink,
  uploadFile,
  updateMarketingMaterial,
  deleteMarketingMaterial,
  insertMarketingMaterial,
  requestPrintMaterial,
  getDisclosureDetails,
  getGroupDisclosurePdf,
  getGroupSettings,
};

export default groupService;
